import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { NotificationRef } from '../notification.service';

@Component({
    selector: 'fi-browser-check-notification',
    templateUrl: './browser-check-notification.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./browser-check-notification.component.scss'],
    standalone: false,
})
export class FiBrowserCheckNotificationComponent {
    constructor(@Inject(NotificationRef) private notiRef) {}

    onHideClick() {
        this.notiRef.HideNotification();
    }
}
